import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { BannerBackground, BannerPromoText } from "./MintGradientBanner.styles";
export var MintGradientBanner = function(param) {
    var children = param.children, text = param.text, className = param.className, onClickTracking = param.onClickTracking;
    return /*#__PURE__*/ _jsxs(BannerBackground, {
        className: className,
        onClick: onClickTracking,
        children: [
            /*#__PURE__*/ _jsx(BannerPromoText, {
                id: "banner-text",
                textColor: "white",
                children: text
            }),
            children
        ]
    });
};
